
import '/data/landun/workspace/vb-web-loan_V4.0D0116_B5_SVN51961bcd_635796/node_modules/.pnpm/@tencent+vue-cli-plugin-vb-web@2.2.5/node_modules/@tencent/vue-cli-plugin-vb-web/inject/public-path.js'
  import _regeneratorRuntime from "/data/landun/workspace/vb-web-loan_V4.0D0116_B5_SVN51961bcd_635796/node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/data/landun/workspace/vb-web-loan_V4.0D0116_B5_SVN51961bcd_635796/node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "/data/landun/workspace/vb-web-loan_V4.0D0116_B5_SVN51961bcd_635796/node_modules/.pnpm/core-js@3.27.1/node_modules/core-js/modules/es.array.iterator.js";
import "/data/landun/workspace/vb-web-loan_V4.0D0116_B5_SVN51961bcd_635796/node_modules/.pnpm/core-js@3.27.1/node_modules/core-js/modules/es.promise.js";
import "/data/landun/workspace/vb-web-loan_V4.0D0116_B5_SVN51961bcd_635796/node_modules/.pnpm/core-js@3.27.1/node_modules/core-js/modules/es.object.assign.js";
import "/data/landun/workspace/vb-web-loan_V4.0D0116_B5_SVN51961bcd_635796/node_modules/.pnpm/core-js@3.27.1/node_modules/core-js/modules/es.promise.finally.js";
import 'lib-flexible';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import enGB from './locales/en-GB/main.json';
import zhCN from './locales/zh-CN/main.json';
import zhHK from './locales/zh-HK/main.json';
import { i18n, launchInit, statPlugin } from '@tencent/vb-web-base';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { createPinia } from 'pinia';
var pinia = createPinia();
pinia.use(createPersistedState({
  storage: sessionStorage
}));
i18n.init({
  'en-GB': enGB,
  'zh-CN': zhCN,
  'zh-HK': zhHK
}, 'en-GB').then( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(i18nInit) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return launchInit();

          case 2:
            createApp(App).use(i18nInit).use(pinia).use(router).use(statPlugin).mount('#app');

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());